module.exports = __webpack_public_path__ + "static/media/coffee_shop.1bbd284d.jpg";